<!--
 * @Author: your name
 * @Date: 2025-08-22 18:34:46
 * @LastEditTime: 2025-08-22 20:17:47
 * @LastEditors: 192.168.1.59
 * @Description: In User Settings Edit
 * @FilePath: /fe-app/src/views/insurance/Article1 copy.vue
-->
<template>
  <div class="box">
    <div class="txt">
      <div class="title">文旦安心保--玉环市地方财政补贴性文旦热带气旋风力指数</div>
      <div class="subtitle">一、试点范围及保险对象</div>
      <div class="paragraph">
        （1）试点范围：根据省政府办公厅《关于鼓励开展特色农业保险品种试点工作的通知》(浙政办发〔2012〕14号)和省发改委等部门《关于进一步完善农业保险政策的通知》（浙发改综体〔2016〕6号）文件要求，经市政府同意，决定自2025年7月1日起实施文旦热带气旋风力指数保险试点工作，试点期为两年，试点范围为玉环经济开发区湿地公园内。
      </div>
      <div class="paragraph">
        （2）保险对象：为了鼓励农产品规模化、集约化经营，试点阶段拟对生产集中化程度较高、管理水平较好、文旦种植数量在十亩以上的大户进行试点承保，并根据业务开展情况逐步扩面。
      </div>
      <div class="subtitle">二、保险金额</div>
      <div class="paragraph">
        保险文旦的每亩保险金额参照保险文旦生长期内所发生的直接物化成本，包括肥料成本、农药成本、灌溉成本、机耕成本等。拟按基本保障的原则，确定文旦热带气旋风力指数保险金额为3000元/亩。
      </div>
      <div class="subtitle">三、保险责任</div>
      <div class="paragraph">
        在保险期间内因投保地理区域受到热带气旋影响，且本保险合同约定的气象站观测到的日极大风速≥20.8米/秒，视为发生热带气旋事故，保险人按本保险合同约定承担赔偿责任。
      </div>
      <div class="paragraph">
        热带气旋影响的判断依据以当地气象台发布的台风预警信号为准。热带气旋影响起止时间以当地气象台发布和解除台风预警信号的时间为准。
      </div>
      <div class="subtitle">四、保险期间</div>
      <div class="paragraph">
        保险期间为每年7月1日至10月31日。
      </div>
      <div class="subtitle">五、赔偿处理</div>
      <div class="paragraph">
        在保险单约定的投保地理区域内，保险文旦发生保险责任范围内的损失，保险人按以下方式计算赔偿：
      </div>
      <div class="paragraph">
        1.投保人和保险人一致同意，投保地理区域内以本保险合同约定的下列气象站观测到的日极大风速数据作为计算赔偿金额的依据。
      </div>
      <div class="image">
        <img src="@/assets/images/table.jpg" alt="" />
      </div>
      <div class="paragraph">
        根据保险期间内投保地理区域的日极大风速对应的赔偿标准来衡量其造成保险文旦的损失是基于历史经验对实际损失的最佳估计，是双方都认可的合理、有效的损失计算方法。用该方法计算的损失和赔款，可能高于被保险人的实际损失，也可能低于被保险人的实际损失。投保人和保险人一致同意，无论实际损失如何，最终赔偿金额均根据本保险合同约定的日极大风速对应的赔偿计算标准确定。
      </div>
      <div class="paragraph">
        2.热带气旋事故以气象站明细表中所有气象站观测的日极大风速作为认定赔偿比例的依据，选取日极大风速出现的日期对应的最高赔偿比例计算热带气旋赔偿金额。赔偿标准如下表：
      </div>
      <div class="image">
        <img src="@/assets/images/table2.jpg" alt="" />
      </div>
      <div class="paragraph">热带气旋赔偿金额=每亩保险金额×热带气旋事故期间日极大风速出现的日期对应最高赔偿比例×保险面积</div>
      <div class="paragraph">若保险期间内发生多次热带气旋事故，仅将最高一次热带气旋赔偿金额作为最终赔偿金额，而不重复赔付。</div>
      <div class="subtitle">六、费率测算</div>
      <div class="paragraph">
        保险费率为12%
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {}
  }
}
</script>

<style lang="stylus" scoped>
body{
  width: 100%
  .box{
    height: 100vh
    overflow-y: scroll
    padding: 30px
    .txt{
        text-align: left
        font-size: 24px
        .subtitle{
          margin-top: 15px;
          font-weight: bold
        }
        .title{
          font-size: 32px
          text-align: center
          font-weight: bold
          margin-bottom: 20px
        }
        .paragraph{
          text-indent: 2em
        }
      }
  }
}
</style>
